// The Harvest card's pure rules: which stocks a run carries, and the
// Sellable Today date.
import dayjs from "dayjs";
import { HarvestStockCounts } from "helpers/types";

/**
 * Whether `symbol` is one of the run's stocks. Read as an OWN property: the
 * map comes off the response, so a symbol like "constructor" would otherwise
 * resolve up the prototype chain to a truthy function.
 */
export const hasStock = (
  stocks: Record<string, HarvestStockCounts>,
  symbol: string,
): boolean => Object.prototype.hasOwnProperty.call(stocks, symbol);

// "Sellable Today" on paper with no date is the strongest false claim this
// card can make: the count is the account's latest position snapshot, which
// can be days old, and the word "Today" invites the reader to read it as
// this morning's. The caption beside the figure says the date on screen;
// the PDF has no room for a caption, so the export folds it into the label
// the way the OEA Max Drop's bucket list is folded into its own.
export const SELLABLE_TODAY_PDF_LABEL = "Sellable Today";

/**
 * The day the Sellable Today count was actually taken on.
 *
 * Always shown when there is a backend count, and shown with no
 * drift/coverage test of its own: this date is the account's latest position
 * snapshot and has nothing to do with the period the reader chose, so there
 * is no run in which repeating it is noise -- and the row's own label says
 * "Today", which is the one thing the date may need to contradict.
 */
export const sellableAsOfCaption = (asOf: string | null): string | null =>
  asOf ? `as of ${dayjs(asOf).format("MM/DD/YYYY")}` : null;
